import { FC, useMemo } from "react";
import { TextField } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface AgGridGroupingSelectTriggerProps {
  open: boolean;
  openDialog(): void;
  selectedValues: string[];
  groupingOptions: Record<string, string>;
}

export const AgGridGroupingSelectTrigger: FC<
  AgGridGroupingSelectTriggerProps
> = ({ selectedValues, openDialog, open, groupingOptions }) => {
  const renderValue = useMemo(() => {
    if (!selectedValues.length) {
      return "";
    }

    const firstLabel = groupingOptions[selectedValues.at(0) as string];

    if (selectedValues.length === 1) {
      return firstLabel;
    }

    return `${firstLabel} + ${selectedValues.length - 1}`;
  }, [groupingOptions, selectedValues]);

  return (
    <TextField
      size="xsmall"
      label={!selectedValues.length && !open ? "None" : "Group By"}
      focused={open}
      value={renderValue}
      onClick={openDialog}
      InputProps={{
        readOnly: true,
        sx: { cursor: "pointer" },
        endAdornment: open ? (
          <ArrowDropUpIcon fontSize="small" sx={{ color: "action" }} />
        ) : (
          <ArrowDropDownIcon fontSize="small" sx={{ color: "action" }} />
        ),
      }}
      inputProps={{ sx: { cursor: "pointer" } }}
    />
  );
};
